import { io } from 'socket.io-client';
import Cookies from 'js-cookie';
import client from './client';

export const analyticsAPI = {
  getOverview: (params = {}) => client.get('/admin/analytics/overview', { params }),
  getTopPages: (params = {}) => client.get('/admin/analytics/top-pages', { params }),
  getRecentSessions: (limit = 50) => client.get('/admin/analytics/sessions', { params: { limit } }),
  getOnlineNow: () => client.get('/admin/analytics/online'),
  getUserTimeline: (userId, limit = 200) => client.get(`/admin/analytics/users/${userId}/timeline`, { params: { limit } }),
  getCompleteEvents: (page = 1, limit = 50) => client.get('/admin/analytics/events', { params: { page, limit } }),
  getGoogleInsights: (params = {}) => client.get('/admin/analytics/google', { params }),
};

// همان قاعده‌ی TRACK_BASE در utils/tracker.js — چون Socket.IO هم روی همان
// http.Server اصلی (نه یک سرویس جدا) سوار شده است.
const SOCKET_ORIGIN = (process.env.REACT_APP_API_URL || '/api').replace(/\/api\/?$/, '') || window.location.origin;

/**
 * به namespace زنده‌ی پنل ادمین (/live) وصل می‌شود — فقط با توکن ادمین معتبر
 * پذیرفته می‌شود (رجوع کن به src/services/liveSocket.js). برمی‌گرداند یک
 * socket که caller خودش باید در cleanup آن را disconnect کند.
 */
export function connectLiveSocket() {
  const token = Cookies.get('token');
  return io(`${SOCKET_ORIGIN}/live`, {
    auth: { token },
    transports: ['websocket', 'polling']
  });
}
